import { gql } from '../../types/__codegen__/ahm-api';

export const GET_PRODUCT_EXCESS = gql(`
  query getProduct($id: ID!) {
    product(productId: $id) {
      charges {
        excess {
          amount
        }
      }
    }
  }
`);
